import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '@/locales/en/common.json';
import de from '@/locales/de/common.json';
import es from '@/locales/es/common.json';
import fr from '@/locales/fr/common.json';
import nl from '@/locales/nl/common.json';
import enHomepage from '@/locales/en/homepage.json';
import nlHomepage from '@/locales/nl/homepage.json';
import deHomepage from '@/locales/de/homepage.json';
import frHomepage from '@/locales/fr/homepage.json';
import esHomepage from '@/locales/es/homepage.json';
import enVisual from '@/locales/en/visual.json';
import nlVisual from '@/locales/nl/visual.json';
import deVisual from '@/locales/de/visual.json';
import frVisual from '@/locales/fr/visual.json';
import esVisual from '@/locales/es/visual.json';

export const SUPPORTED_LANGS = ['en', 'de', 'es', 'fr', 'nl'];

export const LANG_LABELS = {
  en: 'English',
  de: 'Deutsch',
  es: 'Español',
  fr: 'Français',
  nl: 'Nederlands',
};

export const LANG_FLAGS = {
  en: 'GB',
  de: 'DE',
  es: 'ES',
  fr: 'FR',
  nl: 'NL',
};

// Custom path detector: reads language from first URL segment
const pathDetector = {
  name: 'pathDetector',
  lookup() {
    const parts = window.location.pathname.split('/').filter(Boolean);
    if (parts.length > 0 && SUPPORTED_LANGS.includes(parts[0])) {
      return parts[0];
    }
    return undefined;
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(pathDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: { ...en, homepage: enHomepage, visual: enVisual } },
      de: { translation: { ...de, homepage: deHomepage, visual: deVisual } },
      es: { translation: { ...es, homepage: esHomepage, visual: esVisual } },
      fr: { translation: { ...fr, homepage: frHomepage, visual: frVisual } },
      nl: { translation: { ...nl, homepage: nlHomepage, visual: nlVisual } },
    },
    detection: {
      order: ['pathDetector', 'localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGS,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
